export const styleSheet = (theme: any) => ({
    fullscreenLoader: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        maxWidth: "90px"
    },
    loader: {
        maxWidth: "90px",
        margin: '0 auto'
    }

});try {
    // @ts-ignore
    styleSheet.displayName = "styleSheet";
    // @ts-ignore
    styleSheet.__docgenInfo = { "description": "", "displayName": "styleSheet", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Loading/styles.ts#styleSheet"] = { docgenInfo: styleSheet.__docgenInfo, name: "styleSheet", path: "src/shared/components/Loading/styles.ts#styleSheet" };
}
catch (__react_docgen_typescript_loader_error) { }